import { API_END_POINT, API_METHOD } from '../utils/constants'
import { apiRequest, userAppApiRequest } from './apiWrapper'
import { getApiHeaders } from './deviceRegistrationApi'

export async function logoutAccount() {
    const headers = getApiHeaders()
    const accessToken = localStorage.getItem('access')
    const response = await userAppApiRequest({
        method: API_METHOD.Post,
        url: API_END_POINT.logout,
        headers: {
            ...headers,
            'x-device-id': localStorage.getItem('deviceId'),
            'Authorization': `Bearer ${accessToken}`,
            'x-api-token': accessToken,
        }
    })
    return response
}
